import { gql } from "@apollo/client"

export const CREATE_INVENTORY_PLAN = gql`
  mutation CreateInventoryPlan($input: InventoryPlanInput) {
    createInventoryPlan(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`

export const GET_INVENTORY_PLAN_PAGINATION = gql`
  query GetInventoryPlanPagination($page: Int, $limit: Int, $pagination: Boolean, $academicYearId: ID, $planFor: INVENTORY_PLAN_PLAN_FOR, $date: Date) {
    getInventoryPlanPagination(page: $page, limit: $limit, pagination: $pagination, academicYearId: $academicYearId, planFor: $planFor, date: $date) {
      data {
        _id
        planFor
        date
        academicYearId {
          _id
          academicYear
          academicYearInKhmer
        }
        items {
          _id
          listMaterialUnitId {
            _id
            imageSrc
            qtyInUnit
            costPerUnit
            barcode
            isUse
            remark
            materialId {
              _id
              materialKhName
              materialEnName
              categoryId {
                categoryKhName
                categoryEnName
              }
            }
            unitId {
              _id
              unitKhName
              unitEnName
            }
          }
          qty
          unitPrice
          totalPrice
        }
        remark
        createdAt
        lastUpdatedAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_INVENTORY_PLAN = gql`
mutation UpdateInventoryPlan($id: ID!, $input: InventoryPlanInput) {
  updateInventoryPlan(_id: $id, input: $input) {
    status
    message {
      messageKh
      messageEn
    }
  }
}
`

export const DELETE_INVENTORY_PLAN = gql`
mutation DeleteInventoryPlan($id: ID!) {
  deleteInventoryPlan(_id: $id) {
    status
    message {
      messageKh
      messageEn
    }
  }
}
`